<template>
  <div ref="tabs" class="tabs">
    <div
      v-show="sliderActive"
      :class="['tabs__button', 'tabs__button--left', leftActive ? '' : 'tabs__button--inactive']"
      @click="pushTabs('toRight')"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M23.677 18.52c.914 1.523-.183 3.472-1.967 3.472h-19.414c-1.784 0-2.881-1.949-1.967-3.472l9.709-16.18c.891-1.483 3.041-1.48 3.93 0l9.709 16.18z"/></svg>
    </div>

    <div
      ref="tabsSlider"
      id="tabsSlider"
      class="tabs__content"
    >
      <div
        ref="tabsSliderItems"
        id="tabsSliderItems"
        :style="'margin-left:' + drag.current + 'px'"
        :class="[pushed ? 'tabs__items--transition' : '']"
      >
        <transition-group
          tag="div"
          class="tabs__items"
        >
          <slot />
        </transition-group>
      </div>
    </div>

    <div
      v-show="sliderActive"
      :class="['tabs__button', 'tabs__button--right', rightActive ? '' : 'tabs__button--inactive']"
      @click="pushTabs('toLeft')"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M23.677 18.52c.914 1.523-.183 3.472-1.967 3.472h-19.414c-1.784 0-2.881-1.949-1.967-3.472l9.709-16.18c.891-1.483 3.041-1.48 3.93 0l9.709 16.18z"/></svg>
    </div>
  </div>
</template>

<script>
import helperMethods from '@/helpers/utility'

export default {
  data () {
    return {
      windowWidth: window.innerWidth,
      sliderActive: false,
      mounted: false,
      pushed: false,
      drag: {
        current: 0,
        x: 0,
        dragging: false,
        preventToggle: false
      }
    }
  },
  computed: {
    leftActive () {
      if (this.mounted) {
        let check = this.drag.current < 0 ? true : false
        return check
      }

      return true
    },
    rightActive () {
      if (this.mounted) {
        let check = (this.$refs.tabsSliderItems.offsetWidth + this.drag.current) > this.$refs.tabsSlider.clientWidth ? true : false
        return check
      }

      return true
    }
  },
  methods: {
    pushTabs (direction) {
      this.pushed = true
      let newXPos = 0

      if (direction === 'toLeft') {
        newXPos = this.drag.x - this.$refs.tabsSlider.clientWidth + 40
      } else if (direction === 'toRight') {
        newXPos = this.drag.x + this.$refs.tabsSlider.clientWidth - 40
      }

      this.dragItems(newXPos)

      setTimeout(function () {
        this.pushed = false
      }.bind(this), 600)
    },
    dragItems (xPos) {
      if (this.$refs.tabsSliderItems.offsetWidth > this.$refs.tabsSlider.clientWidth) {
        if (this.drag.current + xPos - this.drag.x > 0) {
          this.drag.current = 0
          this.drag.x = xPos
        } else if (this.drag.current + xPos - this.drag.x < this.$refs.tabsSlider.clientWidth - this.$refs.tabsSliderItems.offsetWidth) {
          this.drag.current = this.$refs.tabsSlider.clientWidth - this.$refs.tabsSliderItems.offsetWidth
          this.drag.x = xPos
        } else {
          this.drag.current = this.drag.current + xPos - this.drag.x
          this.drag.x = xPos
        }
      }
    },
    onResize() {
      this.windowWidth = window.innerWidth

      if (this.$refs.tabsSliderItems && this.$refs.tabsSliderItems.offsetWidth >= this.$refs.tabs.clientWidth) {
        this.sliderActive = true
      } else {
        this.sliderActive = false
        this.drag.current = 0
      }
    },
    ...helperMethods
  },
  mounted () {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)

      document.getElementById('tabsSlider').addEventListener('mousedown', e => {
        this.drag.x = e.clientX
        this.drag.dragging = true
        let that = this

        setTimeout(function () {
          if (that.drag.dragging === true) {
            that.drag.preventToggle = true
          }
        }, 500)
      }, { passive: true})

      document.getElementById('tabsSlider').addEventListener('touchstart', e => {
        if (e.targetTouches[0]) {
          this.drag.x = e.targetTouches[0].pageX
          this.drag.dragging = true
        }
      }, { passive: true})

      window.addEventListener('mousemove', e => {
        if (this.drag.dragging === true) {
          this.dragItems(e.clientX)
        } else {
          this.drag.preventToggle = false
        }
      }, { passive: true})

      window.addEventListener('mouseup', e => {
        if (this.drag.dragging === true) {
          this.dragItems(e.clientX)
          this.drag.x = 0
          this.drag.dragging = false
          let that = this

          setTimeout(function () {
            that.drag.preventToggle = false
          }, 10)
        }
      }, { passive: true})

      window.addEventListener('touchmove', e => {
        if (e.targetTouches[0]) {
          if (this.drag.dragging === true) {
            this.dragItems(e.targetTouches[0].pageX)
          } else {
            this.drag.preventToggle = false
          }
        }
      }, { passive: true})

      window.addEventListener('touchend', e => {
        if (e.targetTouches[0]) {
          if (this.drag.dragging === true) {
            this.dragItems(e.targetTouches[0].pageX)
            this.drag.x = 0
          }
        }
        this.drag.dragging = false
      }, { passive: true})

      if (this.$refs.tabsSliderItems.offsetWidth >= this.$refs.tabsSlider.clientWidth) {
        this.sliderActive = true
      }

      this.mounted = true
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.nextItem)
    window.removeEventListener('mousedown', this.nextItem)
    window.removeEventListener('mouseup', this.nextItem)
    window.removeEventListener('mousemove', this.nextItem)
    window.removeEventListener('touchstart', this.nextItem)
    window.removeEventListener('touchend', this.nextItem)
    window.removeEventListener('touchmove', this.nextItem)
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.tabs {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  background-color: $bg-2;
  border-top: 1px solid rgba($white, 0.1);
  border-bottom: 1px solid $black;
  white-space: nowrap;
  user-select: none;

  &:hover {
    .tabs__button {
      fill: rgba($white, 0.1);
      background-color: $bg-2;
    }

    .tabs__button:not(.tabs__button--inactive) {
      fill: rgba($white, 0.7);
    }
  }

  &__button {
    display: flex;
    border-radius: 999px;
    align-items: center;
    user-select: none;
    padding: 7px 8px 9px 8px;
    transition: background-color 0.2s ease-out;
    background-color: $bg-2;
    fill: $bg-4;

    &:hover:not(.tabs__button--inactive) {
      fill: $white !important;
      cursor: pointer;

      svg {
        transform: scale(1.15);
      }
    }

    &:focus, &:active {
      svg {
        transform: scale(1) !important;
      }
    }

    &--left {
      transform: rotate(270deg);
      margin: 0px 2px 0px 0px;
    }

    &--right {
      transform: rotate(90deg);
      margin: 0px 0px 0px 2px;
    }

    svg {
      transition: fill 0.2s ease-out;
      width: 14px;
      height: 14px;

      @media screen and (min-width: $breakpointLg) {
        width: 16px;
        height: 16px;
      }
    }
  }

  &__content {
    position: relative;
    z-index: 5;
    flex: 1;
    display: flex;
    overflow: hidden;
    white-space: nowrap;
  }

  &__items {
    display: inline-flex;
    align-items: center;

    &--transition {
      transition: margin 0.3 ease-in-out;

      @media screen and (min-width: $breakpointSm) {
        transition: margin 0.4s ease-in-out;
      }

      @media screen and (min-width: $breakpointMd) {
        transition: margin 0.5s ease-in-out;
      }

      @media screen and (min-width: $breakpointLg) {
        transition: margin 0.6s ease-in-out;
      }
    }
  }
}

</style>
